
function winOpen(url) {
  if (window.focus()) {
	self.focus();
  }
  window.open(url,"new","width=480,height=750,status=NO,scrollbars=yes,border=0");
}

function MM_jumpMenu(targ,selObj,restore){ //v3.0
  eval(targ+".location='"+selObj.options[selObj.selectedIndex].value+"'");
  if (restore) selObj.selectedIndex=0;
}
function popShorex(url) {
  if (window.focus()) {
	self.focus();
  }
  window.open(url,"new","resizable=yes,toolbar=no,location=no,width=630,height=475,directories=no,status=no,scroll=yes,scrollbars=yes,menubar=no");
}
function popVideo(url) {
  if (window.focus()) {
	self.focus();
  }
  window.open(url,"new","resizable=yes,toolbar=no,location=no,width=547,height=550,directories=no,status=no,scroll=yes,scrollbars=yes,menubar=no");
}
function pyvPop(url) {
  if (window.focus()) {
	  self.focus();
	}
  window.open(url,"new","resizable=no,toolbar=no,location=no,width=510,height=490,directories=no,status=no,scroll=yes,scrollbars=yes,menubar=no");
}
function previewPdf() {
   var url = "/planner/shorex/pdf/ports/pdf_FJ1.pdf";
   window.open(url);
}
